import { render } from "./EventCalendarCardShimmer.vue?vue&type=template&id=f6db05c8"
const script = {}
script.render = render

export default script